var BasicPager = React.createClass({
  propTypes: {
    currentPage: React.PropTypes.number.isRequired,
    maxPage: React.PropTypes.number.isRequired,
    onPageClicked: React.PropTypes.func.isRequired
  },
  pageClicked(num) {
    this.props.onPageClicked(num);
  },
  render() {
    let {
      currentPage,
      maxPage
    } = this.props;

    let prevClicked = this.pageClicked.bind(this, currentPage - 1);
    let nextClicked = this.pageClicked.bind(this, currentPage + 1);

    return (
      <div className="basic-pager">
        <button
          className="btn btn-default btn-sm"
          disabled={currentPage == 1}
		  aria-label={Labels.getLabel("Previous")} title={Labels.getLabel("Previous")}
          onClick={prevClicked}>
          <span className="fa fa-chevron-left"></span>
        </button>

        <span className="basic-pager__label">{`${Labels.getLabel("Page")} ${currentPage} ${Labels.getLabel("of")} ${maxPage}`}</span>

        <button
          className="btn btn-default btn-sm"
          disabled={currentPage == maxPage}
		  aria-label={Labels.getLabel("Next")} title={Labels.getLabel("Next")}
          onClick={nextClicked}>
          <span className="fa fa-chevron-right"></span>
        </button>
      </div>
    )
  }
})